(function () {
  const DEFAULT = "Stockage SSD=500 GB"; // si champ vide

  function getRecoLabel() {
    const lang = ((document.documentElement && document.documentElement.lang) || "fr")
      .toLowerCase()
      .split("-")[0];
    if (lang === "nl") return "Aanbevolen";
    if (lang === "en") return "Recommended";
    return "Recommandé";
  }

  function clean(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[:：]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function parseReco(raw) {
    const txt = (raw || "").trim() || DEFAULT;
    const parts = txt.split("=");
    if (parts.length < 2) return null;
    return { option: parts[0].trim(), value: parts.slice(1).join("=").trim() };
  }

  function applyRecoFor(vs) {
    if (!vs || vs.__recoApplying) return;
    vs.__recoApplying = true;

    try {
      const conf = parseReco(vs.getAttribute("data-reco"));
      if (!conf) return;

      // reset
      vs.querySelectorAll(".options-selection__option-value-name[data-reco='1']")
        .forEach((el) => {
          el.removeAttribute("data-reco");
          el.removeAttribute("data-reco-label");
        });

      const recoLabel = getRecoLabel();
      const matchesByFieldset = [];

      vs.querySelectorAll("fieldset.options-selection__radios").forEach((fs) => {
        const legend = fs.querySelector("legend.options-selection__option-header");
        if (!legend) return;

        const spans = Array.from(fs.querySelectorAll(".options-selection__option-value-name"));
        const hasValue = spans.some((span) => clean(span.textContent) === clean(conf.value));
        if (!hasValue) return;

        // utile si le nom d'option ne matche pas (FR -> NL)
        matchesByFieldset.push({
          fs,
          legendText: clean(legend.textContent),
          spans,
        });
      });

      // 1) Essai "classique" : option name + value
      const wantedOpt = clean(conf.option);
      const direct = matchesByFieldset.find((m) => m.legendText.includes(wantedOpt));
      if (direct) {
        direct.spans.forEach((span) => {
          if (clean(span.textContent) === clean(conf.value)) {
            span.setAttribute("data-reco", "1");
            span.setAttribute("data-reco-label", recoLabel);
          }
        });
        return;
      }

      // 2) Fallback multi-langue : si la valeur n'existe que dans 1 seul groupe d'options
      if (matchesByFieldset.length === 1) {
        matchesByFieldset[0].spans.forEach((span) => {
          if (clean(span.textContent) === clean(conf.value)) {
            span.setAttribute("data-reco", "1");
            span.setAttribute("data-reco-label", recoLabel);
          }
        });
      }
    } finally {
      vs.__recoApplying = false;
    }
  }

  function run() {
    document.querySelectorAll(".variant-selection[data-reco]").forEach((vs) => {
      applyRecoFor(vs);

      // observe uniquement les changements de contenu (Shopify rerender)
      const obs = new MutationObserver((mutations) => {
        const hasChildChanges = mutations.some((m) => m.type === "childList");
        if (!hasChildChanges) return;
        applyRecoFor(vs);
      });

      obs.observe(vs, { subtree: true, childList: true });
    });
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
